// 运行时配置
import {
  ModuleRegistry,
  AllCommunityModule,
} from 'ag-grid-community';

ModuleRegistry.registerModules([
  AllCommunityModule,
]);

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate

import LazyLoadable from '@/components/LazyLoadable';
import { getRoutesList } from '@/services/role/RoleController'; //真实路由
// import { getRoutesList } from '@/services/router/RouterController'; //静态路由
import { initialStateDefault, RequestSetting, RootContainer, RouterGuards } from '@/settings';
import { PlatformEnum } from '@/settings/enum';
import store from '@/store';
import type { AppWebSocketConfig } from '@/utils/echo';
import { isEmpty } from '@/utils/format';
import { RequestConfig } from '@@/plugin-request/request';
import * as AntdIcons from '@ant-design/icons';
import React from 'react';

declare global {
  interface Window {
    APP_CONFIG: {
      WEBSOCKET_URL: string;
      SITE_TITLE: string;
      DEBUG_MODE: boolean;
      FEATURE_FLAGS: {
        NEW_DASHBOARD: boolean;
        OLD_LEGACY_VIEW: boolean;
      };
    };
    WEBSOCKETCONFIG: AppWebSocketConfig;
  }
}
/**
 * 创建一个临时储存api返回路由的变量
 */
let extraRoutes: Routes.RoutesMenuItem[] = [];

/**
 * 修改交给 react-dom 渲染时的根组件。
 * @param container  JSX.Element
 *args
 *        routes，全量路由配置
 *        plugin，运行时插件机制
 *        history，history 实例
 */
export function rootContainer(container: any) {
  document.onselectstart = function () {
    return true;
  };
  return <RootContainer {...{ container }} />;
}

// 定义 InitialStateType 类型
export type InitialStateType = {
  name?: string;
  collapsed?: boolean;
  layout?: string;
  fixSiderbar?: boolean;
  splitMenus?: boolean;
  [key: string]: any;
};

export async function getInitialState(): Promise<InitialStateType> {
  // const response = await fetch('/config.json'); // 从 public 目录加载
  // if (!response.ok) {
  //   throw new Error(`Failed to load config.json: ${response.statusText}`);
  // }
  // const config = await response.json();
  // const token = store.getState().user.token;
  // if (!isEmpty(token)){
  //   const WebSocketConfig = config.WebSocketConfig

  // }
  // console.log(config);

  return initialStateDefault; // 合并默认配置和加载的配置
}

export const layout = ({ initialState, setInitialState }: any) => {
  const defaultCollapsed = document.documentElement.offsetWidth <= 1000;
  const isCollapsed = initialState?.collapsed !== undefined ? initialState.collapsed : defaultCollapsed;
  const contentDeviationX = document.documentElement.offsetWidth > 767 ? (isCollapsed ? '65px' : '276px') : '0px';

  return {
    ...initialState,
    collapsed: isCollapsed,
    onCollapse: (collapsed: boolean) => {
      setInitialState({ ...initialState, collapsed });
    },
    contentStyle: {
      width: `calc(100vw - ${contentDeviationX})`,
      height: 'calc(100vh - 56px)',
      // padding: '32px 40px',
      // paddingRight: `50px`,
    },
    // headerContentRender: () => <ProBreadcrumb />,
    breadcrumbRender: (routers = []) => {
      return [...routers];
    },
    menu: false,
  };
};

/**
 * 路由守卫
 */
export const onRouteChange = RouterGuards;

/**
 * axios api 请求配置
 */
export const request: RequestConfig = RequestSetting;

// 用来递归处理路由树的函数
const generateRoutes = (routes: Routes.RoutesMenuItem[], parentId: string = '') => {
  return routes.map((route) => {
    const { component, children, meta, id, ...rest } = route;
    const icon = meta.icon;
    const routeId = id;

    const element = component ? LazyLoadable(React.lazy(() => import(`@/${component}`))) : undefined;

    const childRoutes = children ? generateRoutes(children, routeId) : undefined;
    // @ts-ignore
    const iconRoutes = AntdIcons[icon] && LazyLoadable(AntdIcons[icon] as any);

    const data: any = {
      ...rest,
      id: `${id}`,
      ...(!isEmpty(iconRoutes) && { icon: iconRoutes }),
      ...(!isEmpty(element) && { element }),
      ...(!isEmpty(childRoutes) && { children: childRoutes }),
      ...(!isEmpty(parentId) && { parentId }),
    };

    return data;
  });
};

/**
 * 处理动态路由赋值问题
 * @param routes
 */
export function patchClientRoutes({ routes }: { routes: any[] }) {
  // 检查 extraRoutes 是否为空
  if (extraRoutes !== undefined && extraRoutes?.length === 0) {
    console.warn('没有extraRoutes数据,不添加动态路由');
    return;
  }

  const router = routes.find((item) => item.id === 'ant-design-pro-layout');
  // 检查是否找到了指定的 router
  if (!router) {
    console.warn('Router with id "ant-design-pro-layout" not found');
    return;
  }

  // 检查 router.routes 是否存在并且是数组
  if (!Array.isArray(router.routes)) {
    console.warn('Router does not have a valid routes array');
    router.routes = []; // 初始化 routes 为数组
  }

  // 直接使用 map 和 push 修改 router.routes
  const AsyncRoutes = generateRoutes(extraRoutes, '');

  //将children转换为routes格式
  AsyncRoutes?.forEach((item) => {
    const existingRouteIndex = router.routes.findIndex((route: any) => route.path === item.path);
    if (existingRouteIndex === -1) {
      router.routes.push({
        ...item,
        // routes: item.children
      });
    } else {
      console.log(router.routes[existingRouteIndex], item);

      item.children?.forEach((child: any) => {
        router.routes[existingRouteIndex].children.push(child);
      });
    }
  });
}

/**
 * 获取动态路由
 * @param oldRender
 */
export async function render(oldRender: () => void) {
  const token = store.getState().user.token;
  // 平台类型id
  const platform_id = store.getState().platform[PlatformEnum.TYPE];
  // 平台实体id
  const platform_entity_id = store.getState().platform[PlatformEnum.Entity_ID];

  if (!isEmpty(token)) {
    // 获取路由信息
    extraRoutes = await getRoutesList({ platform_id, platform_entity_id });
  }
  oldRender();
}
